import React from 'react'
import Register from "../components/Register/Register.jsx";
const RegisterPage = ({autoclose}) => {
  return (
    <div>
      <Register autoclose={autoclose}/>
    </div>
  )
}

export default RegisterPage
